import { ILL_BE_USER } from '@constants/routes';

export const createLegacyUrl = (url: string, isImpersonated?: boolean, userEmail?: string) =>
  isImpersonated ? `${url}?${ILL_BE_USER}=${userEmail}` : url;
